<template>
  <div>
    <el-row type="flex">
      <div class="bt-hamburger" @click="toggleCollapse">
        <svg-icon 
          class="hamburger" 
          :iconName="isCollapse ? 'menu_unfold':'menu_fold'" 
        />
      </div>
      <div class="page-title">
        {{  currentRouteName }}
      </div>
      <!-- 語言環境切換，再請美化-->
      <div class="language-info">
          <el-link type="primary" @click="toggleLocale()">{{ $store.state.locale == 'tw' ? 'English' : '中文' }}</el-link>
      </div>
      <div class="people-info" >
          <span>
            {{ loginAccount }}
          </span>
          <span class="bt-logout" @click="logoutCheck()">
            <svg-icon 
              class="logout"
              iconName='logout'
            />
          </span>
          
        </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isCollapse: false,
      locale: 'tw', 
    }
  },
  computed: {
    currentRouteName() {
      const currentRouteMenu = this.$store.state.menu.find(m => m.url === this.$route.path.substring(1)) // 對應出當前路由的title
      return this.$store.state.locale === 'en' && currentRouteMenu.enTitle ? currentRouteMenu.enTitle : currentRouteMenu.title;
    },
    loginAccount() {

      // 辨識登入後身份是用戶群組,20230530
      let displayLoginAccount = localStorage.getItem('loginAccount')
      if("group".toLowerCase() == localStorage.getItem('accountType').toLowerCase()) {
        displayLoginAccount = '(多表用戶主帳號)' + displayLoginAccount
      } else if("group_member".toLowerCase() == localStorage.getItem('accountType').toLowerCase()) {
        displayLoginAccount = '(多表用戶子帳號)' + displayLoginAccount
      }

      return displayLoginAccount
    }
  },
  methods: {
    toggleCollapse() {
      this.$store.dispatch('toggleSidebar')
      this.isCollapse = !this.isCollapse
    },
    toggleLocale() { // 依 12-32-N 需求，按此按鈕切換成英文
      if (this.$i18n.locale == 'tw') {
        this.$store.dispatch('toggleLocale', { locale: 'en', i18n: this.$i18n }) // 傳入 選擇的語言 & i18n 實例
      } else {
        this.$store.dispatch('toggleLocale', { locale: 'tw', i18n: this.$i18n }) // 傳入 選擇的語言 & i18n 實例
      }
    },
    resolvePath(url) {
      return this.$router.options.base + url;  // 防止導成相對路徑
    },
    logoutCheck() {
      this.$confirm('確定登出系统嗎？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
      })
    },
    async logout() {
      // console.log('logout')
      // await this.axios.get('/logout')
      location.replace('/logout')
      // location.reload()
      // 清空 localstorage 
      localStorage.clear()
    }
  }
    
}

</script>
